export function CharBar({ count, limit, remaining }: { count: number; limit: number; remaining?: number }) {
  const pct = Math.min(count / limit, 1) * 100;
  const over = count > limit;
  const warn = !over && count > limit * 0.85;
  return (
    <div className="flex items-center gap-1.5 shrink-0" style={{ minWidth: remaining != null ? 90 : 68 }}>
      <div className="flex-1 h-[3px] bg-muted rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all ${over ? 'bg-destructive' : warn ? 'bg-yellow-500' : 'bg-primary/50'}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className={`text-[10px] font-mono tabular-nums leading-none ${over ? 'text-destructive font-semibold' : warn ? 'text-yellow-600 dark:text-yellow-400' : 'text-muted-foreground'}`}>
        {count}/{limit}
        {remaining != null && (
          <span className={`ml-0.5 ${remaining < 5 ? 'text-yellow-600 dark:text-yellow-400' : 'text-muted-foreground/50'}`}>
            ({remaining})
          </span>
        )}
      </span>
    </div>
  );
}
